import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const postWorkspace = async (data) => {
  const response = await axios({
    url: 'config/workspace',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data,
  });
  return response.data;
};

const usePostWorkspace = () => {
  return useMutation((data) => postWorkspace(data));
};

export default usePostWorkspace;
